import { Directive, EventEmitter, Inject, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[onEnter]',
  standalone: true
})
export class OnEnterDirective implements OnInit, OnDestroy {
  @Input() onEnter: (() => void) | null = null;
  @Input() documentLevel: boolean = false;
  @Output() onEnterEvent = new EventEmitter<void>();

  private documentKeydownListener?: (event: KeyboardEvent) => void;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  ngOnInit(): void {
    
    if (this.documentLevel) {
      // Listen on document level like the original AngularJS directive
      this.documentKeydownListener = (event: KeyboardEvent) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
          event.preventDefault();
          
          if (this.onEnter) {
            this.onEnter();
          }
          
          this.onEnterEvent.emit();
        }
      };
      
      this.document.addEventListener('keydown', this.documentKeydownListener);
    }
  }

  ngOnDestroy(): void {
    if (this.documentKeydownListener) {
      this.document.removeEventListener('keydown', this.documentKeydownListener);
    }
  }
}